import axios, { CancelTokenSource } from 'axios';
import API from '../index';
import { Service, Parcel, ShipmentType } from '../../types/common';
import { convertParcelsToBoxes } from './utils';
import { getParcelsActualWeight } from '../../containers/Packages/utils';

let cancelToken: CancelTokenSource;

const isAvailableService = (service: Service) => service.enable && !service.noService;

// If the shipment go through our fulfillment center, we can handle the packing for shipment
// https://www.notion.so/spaceshiphk/Webapp-Ship-document-5714f381eadc4028a85af48abb333088
const isFirstMile = (service: Service) => !!service.firstMileProvider;

interface Request {
  originCountry: string;
  destinationCountry: string;
  parcels: Parcel[];
  shipmentType: ShipmentType;
  hasItemsIncludesFood: boolean;
  hasItemsIncludesBattery: boolean;
}

const getQuotation = async ({
  originCountry,
  destinationCountry,
  parcels,
  shipmentType,
  hasItemsIncludesFood,
  hasItemsIncludesBattery,
}: Request): Promise<Service[]> => {
  if (cancelToken !== undefined) {
    // cancel previous quotation request if any
    cancelToken.cancel();
  }

  cancelToken = axios.CancelToken.source();

  const boxes = convertParcelsToBoxes(parcels);
  const totalWeight = getParcelsActualWeight(parcels);
  const data: Service[] = await API.post(
    '/quotations',
    {
      fromCountry: originCountry,
      toCountry: destinationCountry,
      totalWeight,
      boxes,
      shipmentType,
      hasItemsIncludesFood,
      hasItemsIncludesBattery,
    },
    { cancelToken: cancelToken.token },
  );

  if (shipmentType === ShipmentType.DOCUMENT) {
    return data.filter(isFirstMile).filter(isAvailableService);
  }

  return data.filter(isAvailableService);
};

export default getQuotation;
